import { ActionPayload } from "../types/working-model";

import { Beacon, HvHostMap } from "./helpers";

export function SendTrackingEvent(trackingData: ActionPayload): Promise<boolean> {
	return Beacon(HvHostMap.datalake, '/actions', trackingData);
}
